module.exports = __webpack_public_path__ + "static/media/customer-kitty.c2451f5a.png";